import * as React from "react";
import { styled, Stack, StackProps, Checkbox } from "@mui/material";

interface OutlinedCheckboxProps extends StackProps {
  children?: React.ReactNode;
  checked: boolean;
  contentProps?: StackProps;
  direction?: "row" | "row-reverse";
}

const OutlinedCheckbox: React.FC<OutlinedCheckboxProps> = (props) => {
  const { checked, direction = "row", children, contentProps = {}, ...otherProps } = props;
  return (
    <StyledFormField direction={direction} alignItems="center" spacing={1} checked={checked} {...otherProps}>
      <Checkbox checked={checked} />
      <StyledFormContent flex={1} {...contentProps}>
        {children}
      </StyledFormContent>
    </StyledFormField>
  );
};

export default OutlinedCheckbox;

const StyledFormField = styled(Stack, { shouldForwardProp: (prop) => prop !== "checked" })<{
  checked: boolean;
}>(({ theme, checked, direction }) => ({
  padding:
    direction === "row"
      ? `${theme.spacing(1.5)} ${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(1)}`
      : `${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(2)}`,
  borderRadius: 8,
  border: `1px solid ${theme.palette.backgroundAlpha.border}`,
  cursor: "pointer",
  transition: "all .3s",
  "&:hover": {
    borderColor: theme.palette.backgroundAlpha.borderFocus,
  },
  ...(checked && {
    borderColor: theme.palette.primary.main,
    "&:hover": {
      borderColor: theme.palette.primary.main,
    },
  }),
}));
const StyledFormContent = styled(Stack)(({ theme }) => ({}));
